package de.ohhhmhhh.frontend.admin.ui.screens.episode.edit

data class EpisodeEditState(
    val saved: String? = null,
    val year: Int = 2024,
    val month: Int = 6,
    val items: List<EpisodeEditingItem> = emptyList()
)
